import { useEffect } from 'react';

const SCROLL_KEYS = [
  ' ',
  'PageUp',
  'PageDown',
  'Home',
  'End',
  'ArrowUp',
  'ArrowDown',
];

const isTypingTarget = (target: EventTarget | null) =>
  target instanceof HTMLElement &&
  !!target.closest('input, textarea, select, [contenteditable="true"]');

const isButtonSpace = (event: KeyboardEvent) =>
  event.key === ' ' &&
  event.target instanceof HTMLElement &&
  !!event.target.closest('button');

export const usePageScrollLock = (isLocked: boolean) => {
  useEffect(() => {
    if (!isLocked) {
      return;
    }

    const preventWheelScroll = (event: WheelEvent) => {
      if (event.ctrlKey) {
        return;
      }

      event.preventDefault();
    };

    const preventKeyScroll = (event: KeyboardEvent) => {
      const isScrollKey = SCROLL_KEYS.includes(event.key);

      if (
        !isScrollKey ||
        isTypingTarget(event.target) ||
        isButtonSpace(event)
      ) {
        return;
      }

      event.preventDefault();
    };

    document.addEventListener('wheel', preventWheelScroll, { passive: false });
    document.addEventListener('keydown', preventKeyScroll);

    return () => {
      document.removeEventListener('wheel', preventWheelScroll);
      document.removeEventListener('keydown', preventKeyScroll);
    };
  }, [isLocked]);
};
